import { convertValue } from "../controlledReduxModule/actions";
import { Actions } from "core/utils/buildSimpleUncontrolledInputModule/actions";

export function uncontrolledChangeValue(
  changeValue: Actions["changeValue"],
): Actions["changeValue"] {
  return (value) => changeValue(convertValue(value as string | null));
}
